// Selectors


import { RootState } from '../../store';

export const staticDataSelector = (state: RootState) => state.staticDataState
